// extracted by mini-css-extract-plugin
export default {"body":"PcrsDetailsDialog_body__QUk7E","loading":"PcrsDetailsDialog_loading__4DGi8"};